"use client"

import { Toaster as MedusaToaster } from "@/components/ui"

/**
 * Точка монтирования тостов (обёртка над sonner). Рендерится один раз
 * в корневом layout; вызовы toast() из "sonner" сами находят его,
 * отдельный провайдер не нужен.
 */
const Toaster = () => {
  return <MedusaToaster />
}

export default Toaster
